/**
 * 環境配置介面
 * 定義應用程式所需的所有環境變數型別
 */
export interface EnvironmentConfig {
  // 環境設定
  /** 當前環境 (development 或 production) */
  environment: 'development' | 'production';
  /** 是否為產品環境 */
  isProduction: boolean;
  /** 是否為開發環境 */
  isDevelopment: boolean;

  // API 配置
  /** API 基礎 URL */
  apiUrl: string;

  // LINE 配置
  /** LINE Channel ID */
  lineChannelId: string;
  /** LINE 重導向 URI */
  lineRedirectUri: string;
  /** LINE Channel Secret */
  lineChannelSecret: string;
  /** LINE 登入 URI */
  lineLoginUri: string;
  /** LINE 登入 Client ID */
  lineLoginClientId: string;
  /** LINE 重導向 URL */
  lineRedirectUrl: string;

  // Google Maps 配置
  /** Google Maps API Key */
  googleMapsApiKey: string;
  /** LIFF ID */
  liffId: string;
}

/**
 * 環境變數驗證錯誤
 */
export class EnvironmentValidationError extends Error {
  constructor(message: string, public missingVariables: string[] = []) {
    super(message);
    this.name = 'EnvironmentValidationError';
  }
}

/**
 * 必要環境變數列表
 */
export const REQUIRED_ENV_VARS = [
  'REACT_APP_ENVIRONMENT',
  'REACT_APP_API_URL',
  'REACT_APP_LINE_CHANNEL_ID',
  'REACT_APP_LINE_REDIRECT_URI',
  'REACT_APP_LINE_CHANNEL_SECRET',
  'REACT_APP_LINE_LOGIN_URI',
  'REACT_APP_LINE_LOGIN_CLIENT_ID',
  'REACT_APP_LINE_REDIRECT_URL',
  'REACT_APP_GOOGLE_MAPS_API_KEY',
  'REACT_APP_LIFF_ID'
] as const;

/**
 * 環境變數型別
 */
export type RequiredEnvVar = typeof REQUIRED_ENV_VARS[number];